import { render, staticRenderFns } from "./DeliveryComponent.vue?vue&type=template&id=5c8904ee&scoped=true&"
import script from "./DeliveryComponent.vue?vue&type=script&lang=js&"
export * from "./DeliveryComponent.vue?vue&type=script&lang=js&"
import style0 from "./DeliveryComponent.vue?vue&type=style&index=0&id=5c8904ee&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c8904ee",
  null
  
)

export default component.exports